import { MultiSelect } from "../base/multiSelect";
import { LocalCustomSelect } from "./customSelect";
export class LocalMultiSelect extends MultiSelect {
    constructor(nativeSelect, renderInline) {
        const localCustomSelect = new LocalCustomSelect(nativeSelect);
        const maxDisplayedItems = parseInt(nativeSelect.data("max-displayed-items"));
        super(Object.assign(Object.assign({}, localCustomSelect.getOptions()), { renderInline, maxDisplayedItems: isNaN(maxDisplayedItems) ? undefined : maxDisplayedItems, noneSelectedText: nativeSelect.data("none-selected-text"), countSelectedText: nativeSelect.data("count-selected-text") }));
        this.nativeSelect = nativeSelect;
        this.localCustomSelect = localCustomSelect;
    }
    insert(customSelect) {
        this.nativeSelect.after(customSelect);
    }
    setSelected(chosenItem) {
        super.setSelected(chosenItem);
        const value = chosenItem.value === undefined ? "" : chosenItem.value;
        const chosenOption = this.nativeSelect
            .find("option")
            .filter((_, o) => $(o).val() === value);
        chosenOption.prop("selected", !chosenOption.prop("selected"));
        this.nativeSelect.trigger("change");
    }
    addItems(...items) {
        super.addItems(...items);
        this.localCustomSelect.addItems(...items);
    }
    removeItems(...items) {
        super.removeItems(...items);
        this.localCustomSelect.removeItems(...items);
    }
    enable() {
        super.enable();
        this.localCustomSelect.enable();
    }
    disable() {
        super.disable();
        this.localCustomSelect.disable();
    }
}
